import * as React from 'react';
import { AgendaEventsLoadingListView as LoadingView } from 'owa-agenda-loading-events';

const styles = require('./AgendaLoadingView.scss');

export default function AgendaLoadingView() {
    return (
        <div className={styles.container}>
            <LoadingView isDataLoaded={false} />
        </div>
    );
}
